// extracted by mini-css-extract-plugin
module.exports = {"shipmethod":"_16MyJ","shipto":"_3XtJo","button":"_3hIqn","notrackingTip":"_3DZ-d","spin":"_1_2GT"};